import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityBoulogneBillancourtPage() {
  const data = citiesData.find((c) => c.slug === "boulogne-billancourt")!;
  return <CityPage data={data} />;
}
